module.exports = __webpack_public_path__ + "img/25.488710b0.gif";